export const EMAIL_FIELD_NAME = 'email' as const;
export const SECONDARY_EMAIL_FIELD_NAME = 'email2' as const;
export const CELLPHONE_FIELD_NAME = 'cell_phone' as const;
export const TEXT_FIELD_NAME = 'receive_text_messages' as const;
